import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[egNoSeparatorNumber]',
  standalone: false,
})
export class NoSeparatorNumberDirective {
  private readonly numbersRegex: RegExp = /^\d*$/;

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Backspace' || event.key === 'Delete' || event.key === 'Tab') {
      return;
    }

    if (!this.numbersRegex.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event']) onPaste(event: Event): void {
    if (!this.numbersRegex.test((event as ClipboardEvent).clipboardData.getData('text/plain'))) {
      event.preventDefault();
    }
  }
}
